export * from './from-now.pipe';
export * from './sort-by-date.pipe';
export * from './linkify.pipe';
export * from './capitalize.pipe';
export * from './momentify.pipe';
export * from './duration.pipe';
export * from './to-local-date.pipe';



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/pipes/index.ts